module.exports = __webpack_public_path__ + "static/media/sf-test-1.f4fe9287.mp3";